<template>
    <div class="flex justify-center items-center flex-wrap h-full g-6 ">
    <form @submit.prevent="onformsubmit">
        <div class="grid gap-6">
            <!-- FirstName input -->
            <div class="space-y-2">
                <Label for="firstname" value="نام" class="text-white"/>
                <InputIconWrapper>
                    <template #icon>
                        <UserIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        
                        withIcon
                        id="firstname"
                        type="text"
                        placeholder="نام"
                        class="block w-full"
                        v-model="registerForm.firstName"
                        required
                        autofocus
                        autocomplete="firstname"
                    />
                </InputIconWrapper>
            </div>
            <!-- LastName input -->
            <div class="space-y-2">
                <Label for="lastname" value="نام خانوادگی" class="text-white"/>
                <InputIconWrapper>
                    <template #icon>
                        <UserIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="lastname"
                        type="text"
                        placeholder="نام خانوادگی"
                        class="block w-full"
                        v-model="registerForm.lastName"
                        required
                        autofocus
                        autocomplete="lastname"
                    />
                </InputIconWrapper>
            </div>
            <!-- mobile input -->
            <div class="space-y-2">
                <Label for="mobile" value="موبایل" class="text-white"/>
                <!--<Label  class="text-xs text-white" value="(مثال: 9151234567)" />-->
                <InputIconWrapper>
                    <template #icon>
                        <PhoneIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input
                        withIcon
                        id="mobile"
                        type="mobile"
                        class="block w-full"
                        placeholder="موبایل"
                        v-model="registerForm.mobile"
                        v-on:keypress="isNumber($event)"
                        required
                        autocomplete="username"
                    />
                </InputIconWrapper>
                <span v-if="mobileError" class="text-red-500 text-sm">{{ mobileError }}</span>
            </div>

            <!-- Terms -->
            <div>
                <Label for="acceptterms">
                    <div class="flex items-center">
                        <Checkbox name="acceptterms" id="acceptterms" v-model:checked="registerForm.acceptTerms" />

                        <div class="ml-2 ">
                            موافق شرایط 
                            <a
                                target="_blank"
                                href="#"
                                class="text-sm text-blue-600 underline hover:text-blue-900"
                            >استفاده از خدمات</a> و
                            <a
                                target="_blank"
                                href="#"
                                class="text-sm text-blue-600 underline hover:text-blue-900"
                            >سیاست حفظ حریم خصوصی</a>
                        </div>
                    </div>
                </Label>
            </div>
            <!-- Captcha -->
            <div class="bg-white mt-6 w-52">
                <VueClientRecaptcha
                    :value="inputValue"
                    chars="123456789"
                    :hidelines="false"
                    custom-text-color="black"
                    @getCode="getCaptchaCode"
                    @isValid="checkValidCaptcha"
                >
             
                    <template #icon>
                    <span class="text-blue-500 ">بارگذاری مجدد</span>
                    </template>
                </VueClientRecaptcha>
       
                <input 
                
                    type="text"
                    v-model="inputValue"
                    placeholder="کد را وارد کنید"
                />
            </div>
            <!-- Register button -->
            <div>
                <Button
                        type="submit"
                        class="justify-center w-full gap-2"
                        :disabled="registerForm.processing"
                        @click.once="register"
                    >
                        <UserAddIcon v-if="!registerForm.processing" aria-hidden="true" />
                        <span v-if="!registerForm.processing">ثبت</span>
                        <span v-else>در حال پردازش...</span>
                    </Button>            </div>
            <div class="bg-white"></div>
            
            <!-- Login link -->
            <p class="text-sm text-gray-600 dark:text-gray-400">
                آیا حساب دارید؟
                <router-link :to="{ name: 'Login' }" class="text-blue-500 hover:underline">ورود</router-link>
            </p>
        </div>
    </form>
</div>
</template>

<script>

import VueClientRecaptcha from "vue-client-recaptcha";
import Label from '@/components/Label.vue'
import Input from '@/components/Input.vue'
import Checkbox from '@/components/Checkbox.vue'
import Button from '@/components/Button.vue'

export default {
  name: "Register",
  components: {VueClientRecaptcha,Button,Checkbox,Input,Label},
  data() {
    return {
    inputValue: null,
    isValidCaptcha: false,
    mobileError: null,
    canSubmit: false, // کنترل فعال بودن دکمه ثبت
    registerForm: {
      firstName: '',
      lastName: '',
      mobile: '',
      password: '',
      confirmPassword: '',
      acceptTerms: false,
      processing: false,
    }
  };
},
  methods: {
    getCaptchaCode(capthaResult) {
        console.log(capthaResult);
      },

      checkValidCaptcha(capthaResult) {
        console.log("this is captha valid " + capthaResult);
        this.isValidCaptcha = capthaResult;
      },
    onformsubmit() {this.register();},
    isNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
        },
    validateMobile() {
        let mobile = this.registerForm.mobile;

        // حذف فاصله‌ها و کاراکترهای غیر عددی
        mobile = mobile.replace(/\D/g, '');
        if (mobile.length == 10){
            this.canSubmit = true;
           return true;
        }
        // بررسی شروع با 98 یا +98 و جایگزینی با 0
        if (mobile.startsWith('98')) {
            mobile = '0' + mobile.slice(2);
        } else if (mobile.startsWith('+98')) {
            mobile = '0' + mobile.slice(3);
        }
        
        // بررسی طول شماره موبایل
        if (mobile.length !== 11) {
            this.mobileError = 'شماره موبایل باید ۱۱ رقمی باشد.';
            this.canSubmit = false;

            return false;
        } else {
            this.mobileError = null;
            this.registerForm.mobile = mobile;
            this.canSubmit = true;

            return true;
        }
    },
    register() {
        console.log(777)
    if (!this.validateMobile()) {  // اجرای مجدد اعتبارسنجی موبایل
        return;
    }
    if (!this.canSubmit || this.registerForm.processing) {
        return;
    }
    if (this.isValidCaptcha) {
        this.registerForm.processing = true;
        this.$store.dispatch('register', this.registerForm)
            .then(() => {
                this.$router.push({ name: 'ResetPassword' });
            })
            .catch(error => {
                console.log(error.response.data.Message);
                this.$swal.fire(error.response.data.Message);
                this.registerForm.processing = false;
            });
    } else {
        alert("کد امنیتی وارد شده صحیح نمی باشد");
    }
},
watch: {
    'registerForm.mobile': function(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.mobileError = null;
            this.canSubmit = this.validateMobile();
        }
    }
}

    }
  }
</script>